import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["choiceLotSelectorModal"]

  connect() {
    if (this.hasChoiceLotSelectorModalTarget) {
      this.modal = new Modal(this.choiceLotSelectorModalTarget)
      this.modal.show()
    }
  }

  disconnect() {
    if (this.modal) {
      this.modal.hide()
    }
  }
}
